import { Component, OnInit } from '@angular/core';
import { AdminsListComponent } from '../../lists/admins-list/admins-list.component';

@Component({
    selector: 'app-developer-application-admins',
    templateUrl: './developer-application-admins.component.html',
    styleUrls: ['./developer-application-admins.component.scss'],
    standalone: true,
    imports: [AdminsListComponent]
})
export class DeveloperApplicationAdminsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
